import React, { Suspense, useEffect, useState } from "react";
import Messages from "./Messages";
import Popover from "antd/lib/popover";
import file from "../assets/file.svg";
import emptyCohort from "../assets/empty-cohort.svg";
import { isHtml, UploadFile } from "../services/Utils";
import Editor from "qalort-editor/dist/components/editor/Edit";
import BaseInput from "./BaseInput";
import {
  GetCohortMessages,
  SendCohortAnnouncement,
} from "../services/cohortService";
import { notification } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const CohortMessages = ({
  currentCohort,
  qalortUser,
  createMessageData,
  mentionValues,
}) => {
  const [sending, setSending] = useState(false);
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingFile, setLoadingFile] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState(null);
  const [announcement, setAnnouncement] = useState("");

  const getMessages = async () => {
    setIsLoading(true);
    setMessages([]);
    try {
      const res = await GetCohortMessages(currentCohort?.id);
      setMessages(res.data.data || []);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpload = async (payload, path) => {
    setLoadingFile(true);
    try {
      let response = await UploadFile(payload, {
        service: "users",
        access: "public-read",
        path: `/users/${qalortUser?.id || qalortUser?._id}/${Math.random()
          .toString(36)
          .slice(2, 7)}/`,
      });
      const imgUrl = response.data.data[0];
      setUploadedFiles({
        image: imgUrl,
        cohort_id: currentCohort?.id,
        message: path === "file" ? `${payload.name}` : "---",
        title: "public announcement",
        category: "post",
      });
    } catch (err) {
      console.log(err);

      notification.error({
        message:
          err.response?.data?.message || "An error occured. Please try again",
      });
    } finally {
      setLoadingFile(false);
    }
  };

  const scrollToBottom = () => {
    // messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const sendAnnouncement = async () => {
    setSending(true);

    try {
      let newMessages = [...messages];

      if (uploadedFiles) {
        const filePayload = { ...uploadedFiles };
        await SendCohortAnnouncement(filePayload);
        newMessages = [...newMessages, filePayload];
      }

      if (announcement.trim()) {
        const announcementPayload = {
          cohort_id: currentCohort?.id,
          title: "public announcement",
          category: "post",
          message: announcement.trim(),
        };
        await SendCohortAnnouncement(announcementPayload);
        newMessages = [...newMessages, announcementPayload];
      }

      setAnnouncement("");
      setUploadedFiles(null);
      setMessages(newMessages);
      setAnnouncement("");
    } catch (error) {
      console.log(error);
    } finally {
      setSending(false);
    }
  };

  useEffect(() => {
    if (currentCohort) {
      getMessages();
    }
  }, [currentCohort]);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  return (
    <>
      <div className="px-4 pb-4 relative h-[calc(100vh-290px)]">
        <div className="flex flex-col gap-3 w-full h-[calc(100vh-415px)] overflow-y-auto pt-[90px] pb-[200px] mt-6">
          {isLoading || sending ? (
            <div className="h-full flex justify-center items-center">
              <LoadingOutlined style={{ fontSize: "20px" }} />
            </div>
          ) : !messages.length ? (
            <div className="w-full md:w-[400px] mx-auto text-center max-w-[726px]">
              <p className="text-main text-[16px] font-semibold mb-0">
                Interact with your cohort members!
              </p>
              <p className="text-tint">
                Kick things off! Introduce yourself, ask a question, or upload a
                photo, video, or document to share with your cohort.
              </p>
              <img src={emptyCohort} className="mx-auto" alt="" />
            </div>
          ) : (
            messages?.map((item, i) => {
              return (
                <div key={i}>
                  {" "}
                  {isHtml(item.message) ? (
                    <Messages messageData={item}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.message,
                        }}
                        className="message-wrapper text-main"
                      ></div>
                    </Messages>
                  ) : (
                    <Messages messageData={item}>
                      {!item.image &&
                        item.message !== "---" &&
                        item.message !== "***" &&
                        item.message}
                      {item.image && item.message === "---" && (
                        <Popover
                          content={
                            <div className="w-[500px] h-[500px] overflow-auto flex justify-center items-center">
                              <img
                                src={item.image}
                                alt=""
                                className="w-[500px] mt-4 cursor-pointer"
                              />
                            </div>
                          }
                        >
                          <img
                            src={item.image}
                            alt=""
                            className="w-[300px] mt-4"
                          />
                        </Popover>
                      )}
                      {item.image && item.message !== "---" && (
                        <div className="flex items-center gap-2">
                          <img src={file} alt="" />
                          <div>
                            <p className="p-sm text-dark font-medium mb-0">
                              {item.message}
                            </p>
                            <a
                              download
                              href={item.image}
                              alt=""
                              target="_blank"
                              rel="noreferrer"
                              className="w-[300px] text-light p-2xs font-semibold"
                            >
                              Download File
                            </a>
                          </div>
                        </div>
                      )}
                    </Messages>
                  )}
                </div>
              );
            })
          )}
        </div>

        {currentCohort?.user_id === qalortUser?.id ? (
          <div className=" bg-white bottom-0 absolute w-[calc(100%-50px)] py-4">
            <Suspense fallback={<div>Loading...</div>}>
              <Editor
                isQalortInput
                value={announcement}
                onChange={(e) => {
                  setAnnouncement(e);
                }}
                onFileChange={(e) => handleUpload(e, "file")}
                onSendMessage={(messageData) => {
                  sendAnnouncement(messageData);
                }}
                sendButtonDisabled={sending || loadingFile}
                onCreateMessageData={createMessageData}
                loadingFile={loadingFile}
                mentionValues={mentionValues.length ? mentionValues : []}
              />
            </Suspense>
          </div>
        ) : (
          <div className=" bg-white  py-4">
            <BaseInput
              className="block [@media(min-width:1087px)]:hidden"
              inputClassName="[@media(max-width:1086px)]:px-4"
              placeholder="Only the mentor can send announcements"
              disabled
            />
            <BaseInput
              className="[@media(max-width:1086px)]:hidden block"
              placeholder="Only the mentor of this cohort can send messages or announcements."
              disabled
            />
          </div>
        )}
      </div>
    </>
  );
};

export default CohortMessages;
